import React from "react";

function AuroraBackground() {
  return (
    <div className="aurora-bg" aria-hidden="true">
      <div className="aurora-orb aurora-orb-a" />
      <div className="aurora-orb aurora-orb-b" />
      <div className="aurora-orb aurora-orb-c" />
      <div className="aurora-orb aurora-orb-d" />
      <div className="aurora-veil" />
    </div>
  );
}

export default AuroraBackground;
